/* Photo or title opens the holiday quick view.
   LP buy boxes, Essentials Club, and Bounce Back (ATC-only collections).
   The sheet button uses that card's own add. It does not open checkout. */
(function () {
  if (window.BBE_LP_QUICK_VIEW) return;
  window.BBE_LP_QUICK_VIEW = true;

  var shells = document.querySelectorAll("[data-lp-quick-view]");
  var mini = shells[0];
  if (!mini) return;
  Array.prototype.forEach.call(shells, function (shell, index) {
    if (index > 0) shell.remove();
  });
  if (mini.parentNode !== document.body) document.body.appendChild(mini);

  var card = null;
  var invoker = null;
  var generation = 0;
  var jsonCache = new Map();
  var featureCache = new Map();
  var savedOverflow = "";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';

  function escapeHtml(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, "&#39;");
  }
  function shopRoot() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return base.charAt(base.length - 1) === "/" ? base : base + "/";
  }
  function handleFromCard(source) {
    var direct = source.getAttribute("data-product-handle") || "";
    if (direct) return direct;
    var url = source.getAttribute("data-st11-url") || "";
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }
  function cardKind(source) {
    if (!source) return "";
    if (source.hasAttribute("data-ec-card")) return "ec";
    if (source.classList.contains("collection-bbe-card")) return "gate";
    return "lp";
  }
  function cardTitle(source) {
    return source.getAttribute("data-product-title") || source.getAttribute("data-st11-title") || "";
  }
  function cleanText(node) {
    return node ? node.textContent.replace(/\s+/g, " ").trim() : "";
  }
  function cardAvailable(source) {
    var kind = cardKind(source);
    if (kind === "ec") return source.getAttribute("data-available") === "true";
    if (kind === "gate") {
      var button = source.querySelector(".add-to-cart-button");
      return Boolean(button && !button.disabled && button.getAttribute("data-bbe-waitlist-cta") !== "true");
    }
    return source.getAttribute("data-st11-available") === "true";
  }
  function priceParts(source) {
    var kind = cardKind(source);
    if (kind === "ec") {
      var inbox = cleanText(source.querySelector("[data-ec-card-inbox]"));
      var retail = cleanText(source.querySelector("[data-ec-card-retail]"));
      if (inbox && retail && inbox !== retail) return { now: inbox, was: retail };
      return { now: inbox || retail, was: "" };
    }
    if (kind === "gate") {
      return {
        now: cleanText(source.querySelector("[data-price]")),
        was: cleanText(source.querySelector("[data-compare-price]"))
      };
    }
    var nowEl = source.querySelector("[data-st11-price-display]");
    var wasEl = source.querySelector("[data-st11-compare-display]");
    var was = wasEl && !wasEl.hidden ? cleanText(wasEl) : "";
    var now = cleanText(nowEl);
    if (was === now) was = "";
    return { now: now, was: was };
  }
  function withImageWidth(url, width) {
    var raw = String(url || "").trim();
    if (!raw) return "";
    try {
      var parsed = new URL(raw, window.location.origin);
      if (parsed.hostname === "cdn.shopify.com" || parsed.pathname.indexOf("/cdn/shop/") === 0) {
        parsed.searchParams.set("width", String(width));
      }
      if (parsed.protocol === "http:" || parsed.protocol === "https:") return parsed.href;
    } catch (err) { /* skip */ }
    return "";
  }
  function clipText(text, max) {
    var trimmed = String(text || "").replace(/\s+/g, " ").trim();
    if (trimmed.length <= max) return trimmed;
    return trimmed.slice(0, max).replace(/\s+\S*$/, "") + "…";
  }
  function sanitizeDescription(html) {
    var doc;
    try { doc = new DOMParser().parseFromString(String(html || ""), "text/html"); } catch (err) { return ""; }
    if (!doc) return "";
    var blocks = Array.prototype.filter.call(doc.body.querySelectorAll("p, li, h2, h3, h4"), function (node) {
      return !node.querySelector("p, li");
    });
    var nodes = blocks.length ? blocks : [doc.body];
    var out = [];
    var used = 0;
    var inList = false;
    nodes.forEach(function (node) {
      if (used > 700 || out.length > 12) return;
      var text = clipText(node.textContent || "", 700);
      if (!text) return;
      var isItem = node.tagName === "LI";
      if (isItem !== inList) {
        out.push(isItem ? "<ul>" : "</ul>");
        inList = isItem;
      }
      out.push(isItem ? "<li>" + escapeHtml(text) + "</li>" : "<p>" + escapeHtml(text) + "</p>");
      used += text.length;
    });
    if (inList) out.push("</ul>");
    return out.join("");
  }
  function fetchJson(handle) {
    if (!jsonCache.has(handle)) {
      jsonCache.set(handle, fetch(shopRoot() + "products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; }));
    }
    return jsonCache.get(handle);
  }
  function fetchFeatures(handle) {
    if (!featureCache.has(handle)) {
      featureCache.set(handle, fetch(shopRoot() + "products/" + encodeURIComponent(handle) + "?view=ppup-features", {
        credentials: "same-origin"
      }).then(function (res) { return res.ok ? res.text() : ""; }).then(function (text) {
        var start = text.indexOf("{");
        var end = text.lastIndexOf("}");
        if (start < 0 || end <= start) return [];
        var list = JSON.parse(text.slice(start, end + 1)).features;
        return Array.isArray(list) ? list : [];
      }).catch(function () { return []; }));
    }
    return featureCache.get(handle);
  }
  function paintReviews(source) {
    var slot = mini.querySelector("[data-lgg-mini-reviews]");
    if (!slot || !source) return;
    var fromCard = source.querySelector(".lp-collection-card__reviews, .ec-skio-card__rating, .item-card__rating");
    if (!fromCard || !cleanText(fromCard)) { slot.hidden = true; slot.innerHTML = ""; return; }
    slot.hidden = false;
    slot.innerHTML = fromCard.innerHTML;
    slot.setAttribute("aria-label", fromCard.getAttribute("aria-label") || "5 star rated");
  }
  function paintPrice(source) {
    var slot = mini.querySelector("[data-lgg-mini-price]");
    if (!slot || !source) return;
    var parts = priceParts(source);
    slot.innerHTML = (parts.was ? "<s>" + escapeHtml(parts.was) + "</s>" : "") + (parts.now ? "<span>" + escapeHtml(parts.now) + "</span>" : "");
  }
  function syncCta(source) {
    var button = mini.querySelector("[data-lgg-mini-add]");
    if (!button || !source) return;
    if (!cardAvailable(source)) {
      button.disabled = true;
      button.textContent = "Sold out";
      return;
    }
    if (cardKind(source) === "lp" && source.classList.contains("is-selected")) {
      button.disabled = true;
      button.textContent = "Added";
      return;
    }
    button.disabled = false;
    var amount = priceParts(source).now;
    button.textContent = amount ? "Add to cart · " + amount : "Add to cart";
  }
  function variantHtml(source) {
    var select = source.querySelector("[data-st11-variant-select], [data-ec-variant-select], .item-card__variant-select");
    if (!select || select.options.length < 2) return "";
    var labelEl = source.querySelector(".lp-collection-card__variant label");
    var name = "Option";
    if (labelEl) {
      var text = labelEl.textContent.replace(/\s+/g, " ").trim();
      var cut = text.indexOf(" for ");
      if (cut > 0) name = text.slice(0, cut);
    }
    var options = Array.prototype.map.call(select.options, function (opt) {
      return '<option value="' + escapeAttr(opt.value) + '"' +
        (opt.selected ? " selected" : "") +
        (opt.disabled ? " disabled" : "") + ">" +
        escapeHtml(opt.textContent) + "</option>";
    }).join("");
    return '<label class="lgg-mini__variant"><span class="lgg-mini__variant-name">' + escapeHtml(name) +
      '</span><select class="lgg-mini__variant-select" data-lgg-mini-variant-select>' + options + "</select></label>";
  }
  function galleryTrack() {
    return mini.querySelector("[data-lgg-mini-track]");
  }
  function goToSlide(index) {
    var track = galleryTrack();
    var count = track ? track.children.length : 0;
    if (!count) return;
    var next = ((index % count) + count) % count;
    track.scrollTo({ left: next * track.clientWidth, behavior: reduceMotion ? "auto" : "smooth" });
  }
  function renderGallery(images, title) {
    var gallery = mini.querySelector("[data-lgg-mini-gallery]");
    if (!gallery) return;
    var slides = (images || []).map(function (src) {
      return { full: withImageWidth(src, 900), thumb: withImageWidth(src, 120) };
    }).filter(function (slide) { return slide.full; });
    gallery.hidden = slides.length === 0;
    if (!slides.length) { gallery.innerHTML = ""; return; }
    var multi = slides.length > 1;
    gallery.innerHTML =
      '<div class="lgg-mini__track" data-lgg-mini-track' +
      (multi ? ' tabindex="0" role="region" aria-label="' + escapeAttr(title + " images") + '"' : "") + ">" +
      slides.map(function (slide, i) {
        return '<div class="lgg-mini__slide"><img src="' + escapeAttr(slide.full) + '" alt="' +
          escapeAttr(multi ? title + ", image " + (i + 1) + " of " + slides.length : title) +
          '" width="720" height="720"' + (i > 0 ? ' loading="lazy"' : "") + "></div>";
      }).join("") + "</div>" +
      (multi
        ? '<button type="button" class="lgg-mini__nav lgg-mini__nav--prev" data-lgg-mini-step="-1" aria-label="Previous image">' + ICON_PREV +
          '</button><button type="button" class="lgg-mini__nav lgg-mini__nav--next" data-lgg-mini-step="1" aria-label="Next image">' + ICON_NEXT +
          '</button><div class="lgg-mini__thumbs">' +
          slides.map(function (slide, i) {
            return '<button type="button" class="lgg-mini__thumb" data-lgg-mini-go="' + i + '" aria-label="Show image ' + (i + 1) + '"' +
              (i === 0 ? ' aria-current="true"' : "") + '><img src="' + escapeAttr(slide.thumb) + '" alt="" width="56" height="56" loading="lazy"></button>';
          }).join("") + "</div>"
        : "");
    var track = gallery.querySelector("[data-lgg-mini-track]");
    if (multi && track) {
      track.addEventListener("scroll", function () {
        var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        track.parentElement.querySelectorAll("[data-lgg-mini-go]").forEach(function (thumb, i) {
          if (i === index) thumb.setAttribute("aria-current", "true");
          else thumb.removeAttribute("aria-current");
        });
      }, { passive: true });
    }
  }
  function renderFeatures(features) {
    var list = mini.querySelector("[data-lgg-mini-features]");
    if (!list) return;
    var items = (features || []).map(function (item) {
      return { icon: String(item && item.icon || "").trim().toLowerCase(), label: String(item && item.label || "").trim() };
    }).filter(function (item) { return item.label; }).slice(0, 6);
    list.hidden = items.length === 0;
    var lucide = window.lucide;
    list.innerHTML = items.map(function (item) {
      var icon = lucide && /^[a-z0-9-]+$/.test(item.icon)
        ? '<i data-lucide="' + escapeAttr(item.icon) + '" aria-hidden="true"></i>'
        : ICON_CHECK;
      return "<li>" + icon + "<span>" + escapeHtml(item.label) + "</span></li>";
    }).join("");
    if (!items.length || !lucide || typeof lucide.createIcons !== "function") return;
    try { lucide.createIcons({ root: list }); } catch (err) { try { lucide.createIcons(); } catch (err2) { /* labels still read */ } }
    list.querySelectorAll("i[data-lucide]").forEach(function (node) {
      if (node.querySelector("svg")) return;
      node.insertAdjacentHTML("afterend", ICON_CHECK);
      node.remove();
    });
  }
  function lock(on) {
    if (on) {
      savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = savedOverflow;
    }
  }
  function close() {
    if (mini.hidden) return;
    var back = invoker;
    card = null;
    invoker = null;
    mini.hidden = true;
    lock(false);
    if (back && back.isConnected && typeof back.focus === "function") back.focus();
  }
  function open(source, trigger) {
    if (!source) return;
    var handle = handleFromCard(source);
    var title = cardTitle(source);
    var gen = ++generation;
    card = source;
    invoker = trigger || null;
    mini.querySelector("[data-lgg-mini-title]").textContent = title;
    paintReviews(source);
    paintPrice(source);
    mini.querySelector("[data-lgg-mini-variant]").innerHTML = variantHtml(source);
    renderFeatures([]);
    mini.querySelector("[data-lgg-mini-desc]").innerHTML = "";
    syncCta(source);
    var img = source.querySelector(".lp-collection-card__img--primary, .ec-skio-card__img, .item-card__image img");
    var src = (img && (img.currentSrc || img.getAttribute("src"))) || source.getAttribute("data-st11-img") || "";
    renderGallery(src ? [src] : [], title);
    mini.hidden = false;
    var scroller = mini.querySelector("[data-lgg-mini-scroll]");
    if (scroller) scroller.scrollTop = 0;
    lock(true);
    var closeBtn = mini.querySelector(".lgg-mini__close");
    if (closeBtn) closeBtn.focus();
    if (!handle) return;
    fetchFeatures(handle).then(function (features) {
      if (gen !== generation) return;
      renderFeatures(features);
    });
    fetchJson(handle).then(function (product) {
      if (!product || gen !== generation) return;
      var images = (Array.isArray(product.images) ? product.images : []).filter(Boolean).slice(0, 6);
      if (images.length) renderGallery(images, title);
      var desc = sanitizeDescription(product.description);
      var descEl = mini.querySelector("[data-lgg-mini-desc]");
      if (desc && descEl) descEl.innerHTML = desc;
    });
  }
  function choose() {
    if (!card || !cardAvailable(card)) return;
    var kind = cardKind(card);
    var action = null;
    if (kind === "lp") {
      if (card.classList.contains("is-selected")) return;
      action = card.querySelector("[data-st11-toggle]");
    } else if (kind === "ec") {
      action = card.querySelector("[data-ec-add]");
    } else {
      action = card.querySelector(".add-to-cart-button");
    }
    if (!action || action.disabled || action.getAttribute("data-bbe-waitlist-cta") === "true") return;
    close();
    action.click();
  }

  mini.addEventListener("click", function (event) {
    if (event.target.closest("[data-lgg-mini-close]")) { event.preventDefault(); close(); return; }
    if (event.target.closest("[data-lgg-mini-add]")) { event.preventDefault(); choose(); return; }
    var step = event.target.closest("[data-lgg-mini-step]");
    if (step) {
      event.preventDefault();
      var track = galleryTrack();
      var index = track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0;
      goToSlide(index + (parseInt(step.getAttribute("data-lgg-mini-step"), 10) || 0));
      return;
    }
    var go = event.target.closest("[data-lgg-mini-go]");
    if (go) { event.preventDefault(); goToSlide(parseInt(go.getAttribute("data-lgg-mini-go"), 10) || 0); }
  });
  mini.addEventListener("change", function (event) {
    var select = event.target.closest("[data-lgg-mini-variant-select]");
    if (!select || !card) return;
    var cardSelect = card.querySelector("[data-st11-variant-select], [data-ec-variant-select], .item-card__variant-select");
    if (!cardSelect) return;
    cardSelect.value = select.value;
    cardSelect.dispatchEvent(new Event("change", { bubbles: true }));
    paintPrice(card);
    syncCta(card);
  });
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || mini.hidden) return;
    event.preventDefault();
    close();
  });
  document.addEventListener("click", function (event) {
    if (!event.target.closest) return;
    var lpOpener = event.target.closest(".lp-collection-card__media, .lp-collection-card__title");
    if (lpOpener) {
      var lpCard = lpOpener.closest("[data-st11-card]");
      if (!lpCard || !lpCard.closest(".lp-quick-view-on")) return;
      event.preventDefault();
      event.stopPropagation();
      open(lpCard, lpOpener);
      return;
    }
    var ecOpener = event.target.closest(".ec-skio-card__media, .ec-skio-card__title");
    if (ecOpener) {
      var ecCard = ecOpener.closest("[data-ec-card]");
      if (!ecCard || !ecCard.closest(".lp-quick-view-on")) return;
      event.preventDefault();
      event.stopPropagation();
      open(ecCard, ecOpener);
      return;
    }
    var gateOpener = event.target.closest(".item-card__image, .item-card__title");
    if (!gateOpener) return;
    if (event.target.closest("button, a, .favorite-button-wrapper, rivo-favorite-button")) return;
    var gateCard = gateOpener.closest(".collection-bbe-card");
    if (!gateCard || !gateCard.closest(".collection-bbe--atc-only.lp-quick-view-on")) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    open(gateCard, gateOpener);
  }, true);
})();
